import React from 'react';
import {} from 'components/core';
import TasksList from './list';
import TaskDialog from './dialog';
import { ProceduresCtxProvider } from 'components/dataProviders/procedures';

export default function Tasks({mainDialogOpen, handleDialogClose, collapsed, handleShowPanel, dataset})
{

    const handleRowSelected = (row) =>
    {
      handleShowPanel({taskID: row.id});
    }

    const handleCreated = (newID) =>
    {
      handleDialogClose();
      handleShowPanel({taskID: newID});
    }

    return <>
      <ProceduresCtxProvider>
        <TaskDialog open={mainDialogOpen} handleClose={()=>handleDialogClose()} onConfirm={(newID) => handleCreated(newID)}/>
      </ProceduresCtxProvider>
      <TasksList onRowSelected={(row) => handleRowSelected(row)} collapsed={collapsed} handleEdit={(taskID) => handleCreated(taskID)} dataset={dataset} />
    </>
}

